module.exports = __webpack_public_path__ + "img/Melilla.665e862f.svg";